var _circle, _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgChrome = function SvgChrome(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 34,
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 17,
    r: 16.5,
    fill: "#fff",
    stroke: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#00AC47",
    d: "M3.14 25.009a15.98 15.98 0 0 0 12.48 7.934l7.247-12.55L17 17.006l-5.863 3.385-1.955-3.386-1.431-2.479-3.858-6.682a15.99 15.99 0 0 0-.754 17.165"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#EA4435",
    d: "M17 1A15.98 15.98 0 0 0 3.887 7.842l7.246 12.55L17 17.006v-6.771h14.488A16 16 0 0 0 17 1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFBA00",
    d: "M30.86 25.008a15.98 15.98 0 0 0 .631-14.776H17v6.774l5.864 3.385-1.955 3.386-1.432 2.48-3.858 6.682a15.99 15.99 0 0 0 15.242-7.93"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M17 23.78a6.772 6.772 0 1 0 0-13.545 6.772 6.772 0 0 0 0 13.545"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#4285F4",
    d: "M16.999 22.24a5.233 5.233 0 1 0 0-10.465 5.233 5.233 0 0 0 0 10.466"
  })));
};
export default SvgChrome;